import { UserCheck, LogOut } from 'lucide-react';
import { useExitImpersonation, useImpersonation } from '../../features/auth/api.js';

/**
 * Renders a thin orange banner at the top of the app when the
 * current session was opened via admin impersonation. Visible only
 * to the impersonator — the user being acted as never receives the
 * impersonation flag and so never sees this bar. Clicking Exit
 * swaps the cookie back to the admin's prior session.
 */
export function ImpersonationBanner() {
  const q = useImpersonation();
  const exit = useExitImpersonation();

  if (!q.data) return null;

  const handleExit = async () => {
    try {
      await exit.mutateAsync();
      window.location.assign('/admin/users');
    } catch (e) {
      window.alert(`Couldn't exit impersonation: ${(e as Error).message}`);
    }
  };

  return (
    <div role="status" className="impersonation-banner">
      <UserCheck size={14} aria-hidden style={{ flexShrink: 0 }} />
      <span style={{ flex: 1, minWidth: 0 }}>
        Impersonating this account as <strong>{q.data.admin.name}</strong>. The user has not been
        notified.
      </span>
      <button
        type="button"
        onClick={handleExit}
        disabled={exit.isPending}
        className="impersonation-banner-exit"
      >
        <LogOut size={13} style={{ marginRight: 4 }} />
        {exit.isPending ? 'Exiting…' : 'Exit'}
      </button>
    </div>
  );
}
